<form [formGroup]="Form" (submit)="onSubmit()" class="mb-6">
  <nz-alert *ngIf="(codeSent$ | async)" nzType="warning"
            nzMessage="Код подтверждения выслан на почту."
            nzShowIcon></nz-alert>
  <nz-alert *ngIf="!(codeSent$ | async)" nzType="info"
            nzMessage="Заполните поля, для регистрации."
            nzShowIcon></nz-alert>

  <ng-template [ngIf]="!(codeSent$ | async)">
    <div class="form-group mt-3">
      <label for="phone" class="form-label text-muted small">Ваш E-mail для подтверждения аккаунта <span class="text-danger">*</span></label>

      <input
        (change)="cd.detectChanges()"
        (input)="cd.detectChanges()"
        type="email" [email]="true"
        formControlName="email"
        class="form-control form-control-lg justify-content-between"
        placeholder="example@mail.ru"
        id="email"
      />
    </div>
    <div class="form-group">
      <label for="phone" class="form-label text-muted small">Номер телефона (для уведомлений и связи) <span class="text-danger">*</span></label>
      <input
        type="tel"
        formControlName="phone"
        class="form-control form-control-lg justify-content-between"
        placeholder="+7 (___) ___ __ __"
        id="phone"
      />
    </div>
    <div class="form-group">
      <label for="username" class="form-label text-muted small">Ник (username) в телеграм (для уведомлений и связи) <span class="text-danger">*</span></label>
      <input
        type="text"
        formControlName="username"
        class="form-control form-control-lg justify-content-between"
        placeholder="@username"
        id="username"
      />
    </div>
    <div class="form-group mt-3">
      <label for="phone" class="form-label text-muted small">Придумайте пароль для входа <span class="text-danger">*</span></label>
      <input
        (change)="cd.detectChanges()"
        (input)="cd.detectChanges()"
        type="password"
        placeholder="Пароль"
        formControlName="password"
        class="form-control form-control-lg justify-content-between"
        id="password"
      />
    </div>
  </ng-template>


  <div *ngIf="(codeSent$ | async)" class="form-group mt-3">
    <input
      (change)="cd.detectChanges()"
      (input)="cd.detectChanges()"
      type="text"
      [maxLength]="4"
      [minlength]="4"
      placeholder="Код подтверждения"
      formControlName="code"
      class="form-control form-control-lg justify-content-between"
      id="code"
    />
  </div>
  <button [disabled]="Form.invalid" [nzBlock]="true" nzSize="large" nzType="primary"
          class="effectMouse effect-white ant-btn-block"
          [nzLoading]="isLoading$ | async"
          nz-button>
    {{(isLoading$ | async) ? 'Создание аккаунта...' : 'Получить доступ'}}
    <i-feather [style.margin-top.px]="-5" name="log-in"
               class="ml-auto icon-md align-middle"></i-feather>
  </button>
  <!-- Submit -->
  <div class="d-flex justify-content-center mt-3 mb-5">
    <div>
      <i-feather name="chevron-left" class="mr-2 icon-md text-primary"></i-feather>
      <a class="text-underline pointer text-muted"
         (click)="goToAuth()">Войти</a>
    </div>
  </div>

</form>


<nz-alert class="mb-2" *ngIf="lastError" nzType="error"
          [nzMessage]="lastErrorMessage"
          nzShowIcon></nz-alert>
<ng-template #lastErrorMessage>
  {{interfaceService.errorHandling(lastError, false) || 'Неопознаная ошибка, напишите нам или попробуйте чуть позже.'}}
</ng-template>


<nz-alert *ngIf="!(codeSent$ | async)" nzType="info"
          nzMessage="Телеграмм аккаунт выдается автоматически, моментально. Вы сможете пользоваться интерфейсом и пользоваться тестовым периодом."
          nzShowIcon></nz-alert>
